/* Header predictive search. Moved from an inline script in snippets/mega-search.liquid; loaded with defer.
   Liquid values come from the script tag data- attributes (document.currentScript works for deferred scripts). */
var WK_SPELL_JSON = document.currentScript.dataset.spellJson || null;
var WK_SYNONYMS_JSON = document.currentScript.dataset.synonymsJson || null;
  (function(){
    console.log('[wk-search] Script starting to execute');
    const root = document.currentScript.closest('.wk-search');
    if (!root) {
      console.log('[wk-search] ERROR: Could not find .wk-search root element');
      return;
    }
    console.log('[wk-search] Found root element:', root);
    const SEARCH_URL = document.currentScript.dataset.searchUrl;
    const SHOP_CURRENCY = document.currentScript.dataset.currency;
    const SHOP_LOCALE = document.currentScript.dataset.locale;
    const PLACEHOLDER_IMG = ''; // optional: replace with asset_url if you have one

    const input  = root.querySelector('#wk-search-input');
    const panel  = root.querySelector('#wk-search-panel');
    const prodsEl= root.querySelector('#wk-search-products');
    const catsEl = root.querySelector('#wk-search-cats');
    const pagesEl = root.querySelector('#wk-search-pages');
    const pagesWrapEl = root.querySelector('#wk-search-pages-wrap');
    const sugsEl = root.querySelector('#wk-search-suggestions');
    const voiceBtn = root.querySelector('#wk-voice-btn');

    let aborter = null;
    const debounce = (fn,d=220)=>{let t;return(...a)=>{clearTimeout(t);t=setTimeout(()=>fn(...a),d)}};
    
    // Dynamic spell correction and synonym support
    const ENABLE_SPELL_CORRECTION = (document.currentScript.dataset.spellCorrection === 'true');
    const ENABLE_SYNONYMS = (document.currentScript.dataset.synonyms === 'true');
    
    // Load dynamic mappings from theme settings with fallbacks
    let commonWords = {};
    let synonyms = {};
    
    // Parse spell corrections from settings
    try {
      if (ENABLE_SPELL_CORRECTION && WK_SPELL_JSON) {
        commonWords = JSON.parse(WK_SPELL_JSON);
      }
    } catch (e) {
      console.warn('Failed to parse spell corrections from settings, using fallback:', e);
      // Fallback spell corrections
      commonWords = {
        'blak': 'black', 'blck': 'black', 'balck': 'black',
        'whit': 'white', 'wite': 'white', 'whte': 'white',
        'blu': 'blue', 'bleu': 'blue', 'bule': 'blue',
        'red': 'red', 'rd': 'red', 'reed': 'red',
        'grn': 'green', 'gren': 'green', 'grean': 'green',
        'yelo': 'yellow', 'yelow': 'yellow', 'yallow': 'yellow',
        'pnk': 'pink', 'pinck': 'pink', 'pikn': 'pink',
        'shrt': 'shirt', 'sirt': 'shirt', 'shitr': 'shirt',
        'pant': 'pants', 'pnts': 'pants', 'trouser': 'pants',
        'sho': 'shoe', 'shoo': 'shoe', 'shos': 'shoes',
        'dres': 'dress', 'drss': 'dress', 'drees': 'dress',
        'jkt': 'jacket', 'jaket': 'jacket', 'jackt': 'jacket',
        'swtr': 'sweater', 'swetr': 'sweater', 'sweatr': 'sweater'
      };
    }
    
    // Parse synonyms from settings
    try {
      if (ENABLE_SYNONYMS && WK_SYNONYMS_JSON) {
        synonyms = JSON.parse(WK_SYNONYMS_JSON);
      }
    } catch (e) {
      console.warn('Failed to parse synonyms from settings, using fallback:', e);
      // Fallback synonyms
      synonyms = {
        'shirt': ['top', 'blouse', 'tee', 't-shirt', 'polo'],
        'pants': ['trousers', 'jeans', 'slacks', 'bottoms'],
        'shoes': ['footwear', 'sneakers', 'boots', 'sandals'],
        'dress': ['gown', 'frock', 'outfit'],
        'jacket': ['coat', 'blazer', 'cardigan', 'hoodie'],
        'bag': ['purse', 'handbag', 'backpack', 'tote'],
        'watch': ['timepiece', 'clock'],
        'jewelry': ['jewellery', 'accessories', 'ornaments']
      };
    }
    
    // Levenshtein distance for spell correction
    function levenshteinDistance(a, b) {
      const matrix = [];
      for (let i = 0; i <= b.length; i++) matrix[i] = [i];
      for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
      
      for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) === a.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(
              matrix[i - 1][j - 1] + 1,
              matrix[i][j - 1] + 1,
              matrix[i - 1][j] + 1
            );
          }
        }
      }
      return matrix[b.length][a.length];
    }
    
    // Correct spelling and expand with synonyms
    function enhanceQuery(query) {
      const words = query.toLowerCase().split(/\s+/);
      const enhanced = new Set();
      
      words.forEach(word => {
        // Add original word
        enhanced.add(word);
        
        // Check for direct corrections (if enabled)
        if (ENABLE_SPELL_CORRECTION && commonWords[word]) {
          enhanced.add(commonWords[word]);
        } else if (ENABLE_SPELL_CORRECTION) {
          // Find closest match using Levenshtein distance
          let bestMatch = null;
          let bestDistance = Infinity;
          
          Object.keys(commonWords).forEach(key => {
            const distance = levenshteinDistance(word, key);
            if (distance <= 2 && distance < bestDistance) {
              bestDistance = distance;
              bestMatch = commonWords[key];
            }
          });
          
          if (bestMatch) enhanced.add(bestMatch);
        }
        
        // Add synonyms (if enabled)
        if (ENABLE_SYNONYMS) {
          Object.keys(synonyms).forEach(key => {
            if (word === key || enhanced.has(key)) {
              synonyms[key].forEach(syn => enhanced.add(syn));
            }
            if (synonyms[key].includes(word)) {
              enhanced.add(key);
              synonyms[key].forEach(syn => enhanced.add(syn));
            }
          });
        }
      });
      
      return Array.from(enhanced);
    }

    function escapeHtml(str){
      return String(str).replace(/[&<>"'`=\/]/g, s => ({
        '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','`':'&#96;','=':'&#61;','/':'&#47;'
      })[s]);
    }

    function stripHtml(str){
      return String(str || '').replace(/<[^>]*>/g, '');
    }

    function openPanel(){ panel.hidden = false; input.setAttribute('aria-expanded','true'); }
    function closePanel(){ panel.hidden = true; input.setAttribute('aria-expanded','false'); }

    function formatPrice(value){
      try {
        // suggest.json returns prices as DECIMAL strings (e.g. "11.99"),
        // not pence — dividing by 100 here was showing £11.99 as £0.12
        const amount = Number(value);
        if (!isNaN(amount)) {
          return new Intl.NumberFormat(SHOP_LOCALE || undefined, { style:'currency', currency: SHOP_CURRENCY }).format(amount);
        }
        return String(value);
      } catch(e){ return String(value); }
    }

    function renderStars(rating, max=5){
      rating = Math.round(Number(rating) || 0);
      if (!rating) return '';
      let out = '';
      for (let i=1;i<=max;i++) out += i <= rating ? '★' : '☆';
      return `<div class="wk-rating">${out}</div>`;
    }

    // main search logic
    const runSearch = debounce(async function(qRaw){
      const q = qRaw.trim();
      if (!q) { closePanel(); return; }
      if (aborter) aborter.abort();
      aborter = new AbortController();

      // Enhance query with spell correction and synonyms
      const enhancedTerms = enhanceQuery(q);
      const originalQuery = q;
      const searchQuery = enhancedTerms.join(' OR ');

      // Request extra fields (product_type, tag) to derive categories & suggestions from product data
      const url = `${themeRootPath()}search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[type]=product,collection,page,article,query&resources[limit]=12`;

      // DEBUG: Show that search is being triggered
      console.log('[wk-search] Original query:', originalQuery);
      console.log('[wk-search] Enhanced terms:', enhancedTerms);
      console.log('[wk-search] Search query:', searchQuery);
      console.log('[wk-search] API URL:', url);

      try{
        let res = await fetch(url, { signal: aborter.signal, headers: { 'Accept': 'application/json' } });
        // Predictive search doesn't support every storefront language (Arabic returns
        // 417 "Unsupported buyer locale"), so fall back to the default-language index
        // and keep the result links inside the current locale.
        const root = themeRootPath();
        let localise = u => u;
        if (!res.ok && root !== '/') {
          res = await fetch('/' + url.slice(root.length), { signal: aborter.signal, headers: { 'Accept': 'application/json' } });
          localise = u => (typeof u === 'string' && u.charAt(0) === '/' && u.charAt(1) !== '/') ? root + u.slice(1) : u;
        }
        if (!res.ok) throw new Error(`Network response not ok: ${res.status} ${res.statusText}`);
        const data = await res.json();

        // DEBUG: open console and inspect this to confirm the exact shape returned by your store
        // Check resources.results.pages / .articles here to confirm field names (image, body, excerpt, etc.)
        console.log('[wk-search] query:', q, '\n[suggest.json] response:', data);

        const products = data.resources?.results?.products || [];
        const collections = data.resources?.results?.collections || [];
        const pages = data.resources?.results?.pages || [];
        const articles = data.resources?.results?.articles || [];
        const pagesAndArticles = [...pages, ...articles];
        let queries = (data.resources?.results?.queries || []).map(x => x.text).filter(Boolean);

        // PRODUCTS rendering - limit to max 6 products
        const limitedProducts = products.slice(0, 6);
        prodsEl.innerHTML = limitedProducts.length ? limitedProducts.map(p => {
          // image attempts (depends on your suggest response shape)
          const img = p.featured_image?.url || p.featured_image || p.image || PLACEHOLDER_IMG || '';
          const title = escapeHtml(p.title || 'Untitled');
          const href = localise(p.url) || (SEARCH_URL + '?q=' + encodeURIComponent(p.title));
          const price = p.price ? formatPrice(p.price) : (p.price_min ? formatPrice(p.price_min) : '');
          const rating = p.reviews_rating || p.reviews_average || 0; // tries common keys

          return `<li>
            <a class="wk-card" href="${href}">
              <img class="wk-card__img" src="${img ? img + '&width=128' : ''}" alt="${title}">
              <div class="wk-card__meta">
                <div class="wk-card__title">${title}</div>
                ${renderStars(rating)}
                <div class="wk-card__price">${price}${price ? '<span class="vat-note">' + TS('incVat', 'inc. VAT') + '</span>' : ''}</div>
              </div>
            </a>
          </li>`;
        }).join('') : `<li class="wk-empty">${TS('noProducts', 'No products found')}</li>`;

        // CATEGORIES: simple collection display
        catsEl.innerHTML = collections.length ? collections.map(c => `<li><a href="${localise(c.url)}">${escapeHtml(c.title)}</a></li>`).join('') : `<li class="wk-empty">${TS('noCategories', 'No categories')}</li>`;

        // ARTICLES & PAGES: SERP-style rows (image + title + excerpt), full width, below Products
        if (pagesAndArticles.length) {
          pagesWrapEl.style.display = '';
          pagesEl.innerHTML = pagesAndArticles.map(p => {
            const img = p.image?.url || p.image || p.featured_image?.url || p.featured_image || '';
            const title = escapeHtml(p.title || 'Untitled');

            return `<li style="padding:12px 0; border-bottom:1px solid #eee; display:flex; gap:14px; align-items:center;">
              ${img ? `<img src="${img}${img.includes('?') ? '&' : '?'}width=160" alt="${title}" style="width:80px; height:60px; object-fit:cover; border-radius:4px; flex-shrink:0;">` : ''}
              <a href="${localise(p.url)}" style="font-weight:bold; color:#f36f21; font-size:15px; text-decoration:none;">${title}</a>
            </li>`;
          }).join('');
        } else {
          pagesWrapEl.style.display = 'none';
          pagesEl.innerHTML = '';
        }

        // SUGGESTIONS: enhanced with spell corrections and synonyms
        const allSuggestions = new Set();
        
        // Add spell corrections and synonyms if different from original
        if (enhancedTerms.length > 1 || enhancedTerms[0] !== originalQuery.toLowerCase()) {
          enhancedTerms.forEach(term => {
            if (term !== originalQuery.toLowerCase()) {
              allSuggestions.add(term);
            }
          });
        }
        
        // Add API suggestions
        if (queries.length) {
          queries.forEach(q => allSuggestions.add(q));
        }
        
        // Add title-based suggestions if we have products
        if (products.length) {
          const qLower = originalQuery.toLowerCase();
          products.forEach(p => {
            const title = (p.title || '').trim();
            if (title.toLowerCase().includes(qLower)) {
              allSuggestions.add(title);
            }
            
            // split title words to form phrase suggestions
            const words = title.toLowerCase().split(/\s+/).filter(Boolean);
            words.forEach((w, idx) => {
              if (w.includes(qLower) || enhancedTerms.some(term => w.includes(term))) {
                if (idx + 1 < words.length) {
                  allSuggestions.add(`${words[idx]} ${words[idx+1]}`);
                }
                allSuggestions.add(w);
              }
            });
          });
        }
        
        // Convert to array and prioritize
        const suggestionArray = Array.from(allSuggestions)
          .filter(s => s && s.length > 1)
          .sort((a, b) => {
            // Prioritize spell corrections
            const aIsCorrection = enhancedTerms.includes(a) && a !== originalQuery.toLowerCase();
            const bIsCorrection = enhancedTerms.includes(b) && b !== originalQuery.toLowerCase();
            if (aIsCorrection && !bIsCorrection) return -1;
            if (!aIsCorrection && bIsCorrection) return 1;
            // Then by length (longer suggestions first)
            return b.length - a.length;
          })
          .slice(0, 5);

        // render suggestions with spell correction indicators
        sugsEl.innerHTML = suggestionArray.length ?
          suggestionArray.map(s => {
            const isCorrection = enhancedTerms.includes(s) && s !== originalQuery.toLowerCase();
            const label = isCorrection ? `${escapeHtml(s)} <span style="color:#666;font-size:0.9em">(did you mean?)</span>` : escapeHtml(s);
            return `<li><a href="${SEARCH_URL}?q=${encodeURIComponent(s)}">${label}</a></li>`;
          }).join('') :
          `<li class="wk-empty">${TS('noSuggestions', 'No suggestions')}</li>`;

        openPanel();
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error('[wk-search] error', err);
        // graceful fallback UI
        prodsEl.innerHTML = `<li class="wk-empty">${TS('noProducts', 'No products found')}</li>`;
        catsEl.innerHTML = `<li class="wk-empty">${TS('noCategories', 'No categories')}</li>`;
        sugsEl.innerHTML = `<li class="wk-empty">${TS('noSuggestions', 'No suggestions')}</li>`;
        pagesWrapEl.style.display = 'none';
        pagesEl.innerHTML = '';
        openPanel();
      }
    });

    // event listeners
    console.log('[wk-search] Script loaded, attaching event listeners');
    input.addEventListener('input', (e) => {
      console.log('[wk-search] Input event triggered with value:', e.target.value);
      runSearch(e.target.value);
    });
    input.addEventListener('focus', () => {
      console.log('[wk-search] Focus event triggered');
      if (input.value.trim()) runSearch(input.value);
    });
    document.addEventListener('click', (e) => { if (!root.contains(e.target)) closePanel(); });

    // Voice Search Functionality
    if (voiceBtn && 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = SHOP_LOCALE || 'en-US';
      
      let isListening = false;
      
      voiceBtn.addEventListener('click', () => {
        if (isListening) {
          recognition.stop();
          return;
        }
        
        try {
          recognition.start();
          isListening = true;
          voiceBtn.classList.add('listening');
          console.log('[wk-search] Voice recognition started');
        } catch (error) {
          console.error('[wk-search] Voice recognition error:', error);
        }
      });
      
      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        console.log('[wk-search] Voice transcript:', transcript);
        input.value = transcript;
        runSearch(transcript);
        input.focus();
      };
      
      recognition.onstart = () => {
        isListening = true;
        voiceBtn.classList.add('listening');
        console.log('[wk-search] Voice recognition started');
      };
      
      recognition.onend = () => {
        isListening = false;
        voiceBtn.classList.remove('listening');
        console.log('[wk-search] Voice recognition ended');
      };
      
      recognition.onerror = (event) => {
        isListening = false;
        voiceBtn.classList.remove('listening');
        console.error('[wk-search] Voice recognition error:', event.error);
        if (event.error === 'not-allowed') {
          alert('Microphone access denied. Please allow microphone access to use voice search.');
        }
      };
    } else {
      // Hide voice button if speech recognition is not supported
      if (voiceBtn) voiceBtn.style.display = 'none';
      console.log('[wk-search] Speech recognition not supported in this browser');
    }
  })();
